import { Button } from '@launchpad-ui/components';

import { useChartContext } from '../ChartContext';

import styles from './ResetZoomButton.module.css';

/**
 * Component that renders the reset zoom button outside the SVG context.
 * Must be rendered inside ChartProvider to access zoom state.
 * This is temporary until we have a proper reset button in the chart.
 */
export function ResetZoomButton() {
  const { disableDragToZoom, zoomDomain, resetZoom } = useChartContext();

  if (disableDragToZoom || !zoomDomain) {
    return null;
  }

  return (
    <div className={styles.resetZoomButton}>
      <Button
        aria-label="Reset zoom"
        size="small"
        variant="default"
        onPress={resetZoom}
        data-test-id="reset-zoom-button"
      >
        Reset
      </Button>
    </div>
  );
}
